// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_Billing360LedgerRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_Billing360LedgerRow — one ai_credit_ledger row in the
 * billing-360 ledger list.
 *
 * signed_micro is the raw micro-credit delta (negative = debit, positive = credit).
 * created_at is ISO-8601 UTC string (controller converts GMT-3).
 */
import { registerContract } from './validate'

export interface Subscriptions_Billing360LedgerRow {
id: number
entry_type?: string
signed_micro?: number
request_id?: string
created_at?: string
}

registerContract('Subscriptions_Billing360LedgerRow', {
  id:           { type: 'number',  required: true },
  entry_type:   { type: 'string',  required: false },
  signed_micro: { type: 'number',  required: false },
  request_id:   { type: 'string',  required: false },
  created_at:   { type: 'string',  required: false },
})
